import React from 'react';
import cn from 'classnames';
import CompaniesCol from '../../../../../presenters/CompaniesCol';
import HousesCol from '../../../../../presenters/HousesCol';
import RoomsCol from '../../../../../presenters/RoomsCol';
import RelatedRoomsCol from '../../../../../presenters/RelatedRoomsCol';
import styles from './index.module.scss';

const AddressesSetup = ({ className }) => {
  return (
    <div className={cn(styles.root, className)}>
      <CompaniesCol />
      <HousesCol />
      <RoomsCol />
      <RelatedRoomsCol />
    </div>
  );
};

export default AddressesSetup;
